import { ShoppingCart, Plus, Minus, CreditCard, RefreshCw, FileText, BadgeCheck, Box } from 'lucide-react';
import {mockCart} from './Mock'

const CartPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Cart Header */}
        <div className="mb-8 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-600 rounded-lg shadow-lg">
              <ShoppingCart className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Your Design Cart</h1>
              <p className="text-gray-600 mt-1">
                {mockCart.cart.items.length} digital assets selected
              </p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-500">Created: {new Date(mockCart.cart.createdAt).toLocaleDateString()}</p>
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
              {mockCart.cart.status}
            </span>
          </div>
        </div>

        {/* Cart Items */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {mockCart.cart.items.map((item, index) => (
            <div key={index} className="border-b border-gray-100 last:border-b-0 p-8 hover:bg-gray-50 transition-colors">
              {/* Template Section */}
              <div className="mb-6 pb-6 border-b border-gray-100">
                <div className="flex gap-4 items-start">
                  <div className="p-3 bg-blue-50 rounded-xl">
                    <FileText className="w-6 h-6 text-blue-600" />
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900">{item.template.name}</h3>
                        <p className="text-sm text-gray-600 mt-1">{item.template.description}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-semibold text-gray-900">
                          ${item.template.subtotal.toFixed(2)}
                        </p>
                        <p className="text-sm text-gray-500">
                          {item.template.quantity} × ${item.template.price.toFixed(2)}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 mt-4">
                      <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-100">
                        <Minus className="w-4 h-4 text-gray-600" />
                      </button>
                      <span className="w-8 text-center">{item.template.quantity}</span>
                      <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-100">
                        <Plus className="w-4 h-4 text-gray-600" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* License Section */}
              {item.license && Object.keys(item.license).length > 0 && (
                <div className="mb-6 pb-6 border-b border-gray-100">
                  <div className="flex gap-4 items-start">
                    <div className="p-3 bg-green-50 rounded-xl">
                      <BadgeCheck className="w-6 h-6 text-green-600" />
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start">
                        <div>
                          <h4 className="text-md font-semibold text-gray-900">{item.license.name}</h4>
                          <p className="text-sm text-gray-600 mt-1">{item.license.description}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-lg font-semibold text-gray-900">
                            ${item.license.subtotal.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Services Section - Empty state */}
              {item.services.length === 0 && (
                <div className="flex gap-4 items-center text-gray-400">
                  <div className="p-3 bg-gray-50 rounded-xl">
                    <Box className="w-6 h-6" />
                  </div>
                  <p className="text-sm">No additional services selected</p>
                </div>
              )}

              {/* Item Total */}
              <div className="flex justify-between items-center mt-6 pt-6 border-t border-gray-100">
                <p className="text-sm font-medium text-gray-600">Item Total</p>
                <p className="text-xl font-bold text-blue-600">
                  ${item.total.toFixed(2)}
                </p>
              </div>
            </div>
          ))}

          {/* Cart Summary */}
          <div className="p-8 bg-gray-50 border-t border-gray-100">
            <div className="max-w-xl ml-auto space-y-4">
              <div className="flex justify-between items-center">
                <p className="text-gray-600">Subtotal</p>
                <p className="text-gray-900 font-semibold">
                  ${mockCart.cart.totalPrice.toFixed(2)}
                </p>
              </div>
              <div className="flex justify-between items-center">
                <p className="text-gray-600">Taxes</p>
                <p className="text-gray-900 font-semibold">$0.00</p>
              </div>
              <div className="pt-4 border-t border-gray-200">
                <div className="flex justify-between items-center">
                  <p className="text-lg font-bold text-gray-900">Total Amount</p>
                  <p className="text-2xl font-bold text-blue-600">
                    ${mockCart.cart.totalPrice.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-end">
              <button className="px-6 py-3 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 flex items-center gap-2 transition-all">
                <RefreshCw className="w-5 h-5 text-gray-600" />
                <span className="font-medium">Update Cart</span>
              </button>
              <button className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 flex items-center gap-2 transition-all shadow-lg shadow-blue-100">
                <CreditCard className="w-5 h-5" />
                <span className="font-medium">Proceed to Checkout</span>
              </button>
            </div>
          </div>
        </div>

        {/* Security Footer */}
        <div className="mt-8 text-center text-sm text-gray-500 flex items-center justify-center gap-4">
          <span>SSL Secure Checkout</span>
          <span className="h-1 w-1 bg-gray-400 rounded-full" />
          <span>256-bit Encryption</span>
          <span className="h-1 w-1 bg-gray-400 rounded-full" />
          <span>PCI Compliant</span>
        </div>
      </div>
    </div>
  );
};

export default CartPage;